import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MyHttpClient } from '../../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class GuestGeneralInfoService {

    constructor(private http: MyHttpClient) { }

    server = `${environment.server}`;

    getReferralSummary(profileId: string) {
        return this.http.get(`${this.server}/api/pool-manager/profiles/${profileId}/referrals/summary`).pipe(catchError(this.handleError));
    }

    getGuestDetails(id: string) {
        return this.http.get(`${this.server}/api/getGuestDetails/${id}`).pipe(catchError(this.handleError));
    }

    getLifetimeRides(profileId: string) {
        return this.http.get(`${this.server}/api/customer-service/profiles/${profileId}/lifetime-rides`).pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error);
    }
}

